export default __webpack_public_path__ + "static/media/turn-right.e72c3217.svg";